import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PaymentErrorScreenComponent } from '@app/modules/setting/dialogs/payment-error-screen/payment-error-screen.component';
import { loaderTypes } from '@app/shared/component/loader/loader';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/operators';
import { AmplifyHttpClient } from '../auth/http.amplify-httpclient';
import { CryptoService } from '../crypto/crypto.services';

@Injectable({
  providedIn: 'root',
})
export class LocationService {
  constructor(
    private readonly httpService: AmplifyHttpClient,
    private dialog: MatDialog,
    private readonly cryptoService: CryptoService
  ) {}
  /**
   * get user
   * @return user
   */
  getUserLocationList(id) {
    return this.httpService.get<any>(`api/vault/location/${id}`, null, loaderTypes.none).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  createLocationFor(data) {
    //encrypt data before sending to api
    const encryption_key = this.cryptoService.generateEncryptionKey(data.user_pk, null, null);
    data.location_data = this.cryptoService.encryptData(JSON.stringify(data.location_data), encryption_key);
    return this.httpService.post<any>(`api/vault/new-vault-user-location-id`, data).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  updateLocationFor(data) {
    //encrypt data before sending to api
    const encryption_key = this.cryptoService.generateEncryptionKey(data.user_pk, null, null);
    data.location_data = this.cryptoService.encryptData(JSON.stringify(data.location_data), encryption_key);
    return this.httpService.patch<any>(`api/vault/location`, data).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getLocationByFormId(userId, id) {
    return this.httpService.get<any>(`api/vault/form-location/${userId}/${id}`).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  addlocationToFomr(data) {
    return this.httpService.post<any>(`api/vault/form-location`, data).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  deleteLocationAttachToform(userId, FormId, id) {
    return this.httpService.delete<any>(`api/vault/form-location/${userId}/${FormId}/${id}`).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  deletUserUploadedFile(userId, id) {
    return this.httpService.delete<any>(`api/vault/location-upload-file/${userId}/${id}`).pipe(
      map((response) => {
        if (response.status == 200) {
          return response;
        } else {
          return response;
        }
      })
    );
  }
  getfileLisTforLocation(userId, id) {
    return this.httpService.get<any>(`api/vault/vault-user-location-uploads/${userId}/${id}`).pipe(
      map((response) => {
        if (response.status == 200) {
          return response;
        } else {
          return response;
        }
      })
    );
  }

  downloadFile(userid, fileid) {
    let url = `api/vault/vault-user-location-file-download-url/${userid}/${fileid}`;
    return this.httpService.get(url).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        } else {
          return response;
        }
      })
    );
  }

  deleteLocationForUser(userId, id) {
    return this.httpService.delete<any>(`api/vault/location/${userId}/${id}`).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  postCreateLoctionPresignedUrl(request) {
    const url = `api/vault/location-upload-file`;
    let showpopup = true;
    return this.httpService.post(url, request).pipe(
      map((response: any) => {
        if (response.status == 200 || response.status == 201) {
          if (response?.data?.limit_exceeded) {
            if (showpopup) {
              let data: HttpErrorResponse = new HttpErrorResponse({ error: 'Data incorrect', status: 400 });

              const modalRef3 = this.dialog.open(PaymentErrorScreenComponent, {
                panelClass: 'full-window-dialog-2',
                autoFocus: false,
                disableClose: true,
                data: response?.data,
              });
              return this.handleAuthError(data);
            } else {
              let data: HttpErrorResponse = new HttpErrorResponse({ error: response?.data, status: 400 });
              return this.handleAuthError(data);
            }
          } else {
            return response.data;
          }
        } else {
          return response;
        }
      })
    );
  }
  /**
   * manage errors
   * @param err
   * @returns {any}
   */
  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    //handle your auth error or rethrow
    throw err;
  }

  patchFileuploadedStatus(request) {
    const url = `api/vault/location-upload-file`;
    return this.httpService.patch(url, request).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        } else {
          return response;
        }
      })
    );
  }
}
